<template>
  <div class="big-idea-page">

    <header-bar></header-bar>

    <section class="big-idea">
      <div class="grid-container">
        <div class="row">
          <div class="col-6">
            <div class="image-circle">
              <img :src="this.$root.profile.profileimg" />
            </div>
            <div class="info">
              <h4>{{ this.$root.profile.firstname + ' ' + this.$root.profile.surname }}</h4>
              <span class="reputation">{{ this.$root.userrep['.value'] }}</span>
              <h5>{{ this.$root.profile.jobtitle }}</h5>
              <span class="location">{{ this.$root.profile.location }}</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <label>(Optional) Do you have a big idea for Africa {{ this.$root.profile.firstname }}?</label>
            <a class="link-simple">View Example</a>
            <textarea rows="4" v-model.trim="bigIdea" placeholder="My big idea for africa is..."></textarea>
          </div>
        </div>
      </div>
    </section>

    <section class="sign-up-navigation">
      <div class="grid-container">
        <a href="#" v-on:click.stop.prevent="cancel" class="link-back">Cancel</a>
        <a href="#" v-on:click.stop.prevent="save" class="btn btn-big bg-four active">Save</a>
      </div>
    </section>
  </div>
</template>

<script>
import HeaderBar from '@/components/HeaderBar'
import { db } from '@/firebase'
import router from '@/router'

export default {
  data () {
    return {
      bigIdea: this.$root.profile.bigidea
    }
  },
  components: {
    HeaderBar
  },
  methods: {
    cancel () {
      router.go(window.history.back())
    },
    save () {
      let user = this.$root.user.uid
      if (this.bigIdea) {
        db.ref('users/' + user).update({
          bigidea: this.bigIdea
        }, function () {
          // On complete
          console.log('saved')
          router.go(window.history.back())
        })
      } else {
        alert('Unable to save. Please try again.')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// BigIdea.vue?39d40d21